import { useDispatch, useSelector } from 'react-redux';
import { IconSocioeconomic, Modal } from '../../../component';
import Disclaimer from '../../../component/disclaimer';
import { SocioeconomicDemographicCharts } from './charts/socioeconomicDemographicCharts';
import { modalOpen } from '../redux/dashboardActions';

export const BuildingDetailsModalSocioeconomicDemographic = (): JSX.Element => {
  const dispatch = useDispatch();
  const { preference } = useSelector((state: any) => state.layoutState);
  const nls = require(`./nls/${preference.language.id}.json`);
  const { statusModal } = useSelector((state: any) => state.dashboardState);
  const { buildingModalData } = useSelector(
    (state: any) => state.socioeconomicDemographicState
  );

  // Essa lógica será substituida quando o backend for desenvolvido para esta tarefa - começa aqui

  const getResidenceCondition = (data: any): string => {
    if (
      data?.populationLivingInOwnedHouseholds?.value >=
      data?.populationLivingInRentedHouseholds?.value
    ) {
      return data?.populationLivingInOwnedHouseholds?.label;
    } else {
      return data?.populationLivingInRentedHouseholds?.label;
    }
  };

  const getTypeOfResidence = (data: any): string => {
    if (data?.apartment?.count >= data?.house?.count) {
      return data?.apartment?.label;
    } else {
      return data?.house?.label;
    }
  };

  // finaliza aqui

  const modalHead = () => {
    return (
      <div className="socioeconomic-modal-head-container">
        <IconSocioeconomic cy="Modal" />
        <div className="socioeconomic-modal-head-info-container">
          <h1>{nls.modal.head.title}</h1>
          <p>
            {nls.modal.head.subtitle}
            {buildingModalData?.sector}
          </p>
        </div>
      </div>
    );
  };

  return (
    <Modal
      cy="BuildingDetails"
      title={modalHead()}
      open={statusModal === `open building socioeconomic demographic`}
      close={() => dispatch(modalOpen(''))}
      size="large-full"
      borderHeader={true}
      actions
    >
      <div className="modal-detail-socioeconomic">
        <div className="modal-group-external-container">
          <div className="modal-group-internal-container features">
            <h1>{nls.modal.body.titles.features}</h1>
            <div className="modal-group">
              <p>
                <span className="bold">
                  {nls.modal.body.fields.totalPopulation}
                </span>
                {buildingModalData.info?.total_population}
              </p>
              <p>
                <span className="bold">
                  {nls.modal.body.fields.totalHouseholds}
                </span>
                {buildingModalData.info?.total_domiciles}
              </p>
              <p>
                <span className="bold">
                  {nls.modal.body.fields.residentsPerHousehold}
                </span>
                {buildingModalData.info?.dwellers_per_household}
              </p>
            </div>
          </div>
          <div className="modal-group-internal-container industry">
            <div className="modal-group-title-container">
              <h1>{nls.modal.body.titles.industryPredominance}</h1>
              <Disclaimer
                element={nls.modal.body.tooltip.industryPredominance}
                cy="SocioeconomicIndustryPredominanceInfo"
              />
            </div>
            <div className="modal-group-internal-flex-container">
              <div className="modal-group">
                <p>
                  <span className="bold">
                    {nls.modal.body.fields.domicileCondition}
                  </span>
                  {getResidenceCondition(
                    buildingModalData.chartsData?.residenceCondition
                  )}
                </p>
                <p>
                  <span className="bold">
                    {nls.modal.body.fields.domicileType}
                  </span>
                  {getTypeOfResidence(
                    buildingModalData.chartsData?.typesOfResidence
                  )}
                </p>
                <p>
                  <span className="bold">{nls.modal.body.fields.ageGroup}</span>

                  {buildingModalData.info?.age_group}
                </p>
              </div>
              <div className="modal-group">
                <p>
                  <span className="bold">
                    {nls.modal.body.fields.familyIncome}
                  </span>
                  {buildingModalData.info?.family_income}
                </p>
                {buildingModalData?.tablesData?.consumptionByIncome &&
                  buildingModalData.info?.family_income && (
                    <p>
                      <span className="bold">
                        {nls.modal.body.fields.consumptionPotential}
                      </span>
                      {
                        buildingModalData?.tablesData?.consumptionByIncome[
                          buildingModalData.info?.family_income
                        ]?.consumo_medio
                      }
                    </p>
                  )}
              </div>
            </div>
          </div>
        </div>
        <SocioeconomicDemographicCharts />
      </div>
    </Modal>
  );
};
